import { create } from 'zustand';
import type { FortunetellingContextData } from '@/../worker/app/chatbot/FortunetellerPromptManager';

interface FortuneContextState {
  locale: 'EN' | 'JA';
  setLocale: (locale: 'EN' | 'JA') => void;
  getContextData: () => FortunetellingContextData;
}

export const useFortuneContextStore = create<FortuneContextState>()((set, get) => ({
  locale: 'EN',

  setLocale: (locale: 'EN' | 'JA') => {
    set({ locale });
  },

  getContextData: (): FortunetellingContextData => {
    const { locale } = get();
    console.log('returning current context', locale);
    return {
      locale,
      mode: 'fortune-teller',
      fortuneSession: {
        // TODO?
      }
    };
  }
}));
